import { useCallback, useMemo } from "react";

import { ExecutorRating } from "../../services";
import { useTypedSelector } from "../../redux/store";

const useExecutorRatingSubHandler =
	(): useExecutorRatingSubHandler.Props => {
		const executorRatingSubscribe = useTypedSelector(
			(state) => state.globalState.executorRating.data.subscription.basic,
		);

		const getAllExecutorRatingSubHandler = useCallback(
			({
				limit,
				taxiServiceIds,
			}: useExecutorRatingSubHandler.SmallSubscribeOptions): ExecutorRating.Model[] => {
				if (!Array.isArray(executorRatingSubscribe)) {
					return [];
				}

				let retval = [...executorRatingSubscribe];

				if (
					Array.isArray(taxiServiceIds) &&
					taxiServiceIds.length > 0
				) {
					retval = retval.filter(
						(item) =>
							Array.isArray(item.taxiServiceIds) &&
							item.taxiServiceIds.some((id) =>
								taxiServiceIds.includes(id),
							),
					);
				}

				if (typeof limit === "number") {
					retval = retval.slice(0, limit);
				}

				return retval;
			},
			[executorRatingSubscribe],
		);

		return useMemo(
			() => ({
				getAllExecutorRatingSubHandler,
			}),
			[getAllExecutorRatingSubHandler],
		);
	};

declare namespace useExecutorRatingSubHandler {
	interface Props {
		getAllExecutorRatingSubHandler: (
			data: SmallSubscribeOptions,
		) => ExecutorRating.Model[];
	}

	interface SmallSubscribeOptions {
		taxiServiceIds?: number[];
		limit?: number;
	}
}

export default useExecutorRatingSubHandler;
